import * as storage from "app/data/storage";
import { jwtDecode } from "jwt-decode";

export function routeCheck(paths: any, permitAll: boolean = false) {

  if (permitAll) { //case permitAll is true return all pathes
    return paths
  } else { //validate paths and roles
    if (!storage.get('role')) { //check if user role is set
      return []
    } else {
      if (storage.get('accessToken')) { //check user is authenticated
        const userRole = storage.get('role') || ''
        const tokeninfo: any = jwtDecode(storage.get('accessToken') || '{}')

        if (tokeninfo.profiles) { //routine to compare route role with user role
          if (!tokeninfo.profiles.some(profile => profile.role === userRole)) { //check storage manipulation
            return [];
          } else {
            return paths.filter((item: any) => !item.auth || item.auth.includes(userRole)); //filter and return only authorized routes
          }
        } else { //when user dont have profile
          return []
        }
      } else { //user not authenticated
        return []
      }
    }


  }
}